import { PropsWithChildren } from 'react';

import Icon from '@/common/components/Icon/Icon';
import { IconName } from '@/common/components/Icon/iconName';
import MenuItem from '@/common/components/MenuList/MenuItem/MenuItem';

import styles from './PinMenuListItem.module.css';

interface PinMenuListItemProps {
  icon?: IconName;
  onClick?: () => void;
  'aria-label'?: string;
}

function PinMenuListItem(props: PropsWithChildren<PinMenuListItemProps>) {
  const { icon, onClick, 'aria-label': ariaLabel, children } = props;

  return (
    <MenuItem aria-label={ariaLabel} className={styles.pinMenuListItem} onClick={onClick}>
      {icon && <Icon className={styles.pinMenuListItemIcon} name={icon} />}

      {children}
    </MenuItem>
  );
}

export default PinMenuListItem;
